import React from 'react';

const FormattedAddress = ({ props, address, showNeighborhood }) => {
	const street =
		address.street && address.street !== 'Unnamed Road' ? `${address.street}${address.houseNumber ? ` ${address.houseNumber}` : ''},` : '';
	const zip = address.zip ? ` ${address.zip} ` : '';
	const city = address.city ? address.city : '';
	const neighborhood = showNeighborhood ? (address.neighborhood ? ` - ${address.neighborhood}` : '') : '';
	const locationDescription = address.locationDescription
		? `${!street && !zip && !city && !neighborhood ? '' : ' - '}${address.locationDescription}`
		: '';
	return <span {...props}>{`${street}${zip}${city}${neighborhood}${locationDescription}`}</span>;
};

export default FormattedAddress;

export const addressString = ({ address, showNeighborhood }) => {
	if (address.locationDescription) return address.locationDescription;
	const street =
		address.street && address.street !== 'Unnamed Road' ? `${address.street}${address.houseNumber ? ` ${address.houseNumber}` : ''},` : '';
	const zip = address.zip ? ` ${address.zip} ` : '';
	const city = address.city ? address.city : '';
	const neighborhood = showNeighborhood ? (address.neighborhood ? ` - ${address.neighborhood}` : '') : '';
	const locationDescription = address.locationDescription
		? `${!street && !zip && !city && !neighborhood ? '' : ' - '}${address.locationDescription}`
		: '';
	return `${street}${zip}${city}${neighborhood}${locationDescription}`;
};



// WEBPACK FOOTER //
// ./components/FormattedAddress/index.js